export enum Role {
    NetworkAdmin = 'NetworkAdmin',
    Administrator = 'Administrator',
    PartnerAdministrator = 'PartnerAdmin',
    User = 'User',
    SysAdmin = 'SysAdmin'
}
